export const enum MessageBoardActionTypes {
    LOAD_MESSAGES = "MESSAGEBOARD/LOAD_MESSAGES",
    CHANGE_MESSAGES_FILTER = "MESSAGEBOARD/CHANGE_MESSAGES_FILTER",
    UPDATE_VISIT_TIME = "MESSAGEBOARD/UPDATE_VISIT_TIME",
    READ_APPROVALS = "MESSAGEBOARD/READ_APPROVALS",
    ADD_MESSAGE = "MESSAGEBOARD/ADD_MESSAGE",
    POST_MESSAGE = "MESSAGEBOARD/POST_MESSAGE",
    DELETE_MESSAGE = "MESSAGEBOARD/DELETE_MESSAGE",
    DELETE_MESSAGE_FROM_STORE = "MESSAGEBOARD/DELETE_MESSAGE_FROM_STORE",
    DELETE_MESSAGE_REQUEST = "MESSAGEBOARD/DELETE_MESSAGE_REQUEST",
    EDIT_MESSAGE = "MESSAGEBOARD/EDIT_MESSAGE",
    EDIT_MESSAGE_FROM_STORE = "MESSAGEBOARD/EDIT_MESSAGE_FROM_STORE",
    EDIT_MESSAGE_REQUEST = "MESSAGEBOARD/EDIT_MESSAGE_REQUEST",
    SET_MESSAGE_TO_SCROLL_TO = "MESSAGEBOARD/SET_MESSAGE_TO_SCROLL_TO",
    SET_LAST_MESSAGE_VISIBLE = "MESSAGEBOARD/SET_LAST_MESSAGE_VISIBLE",
    SET_FIRST_NEW_MESSAGE_VISIBLE = "MESSAGEBOARD/SET_FIRST_NEW_MESSAGE_VISIBLE",
    SET_EDIT_MESSAGE_ID = "MESSAGEBOARD/SET_EDIT_MESSAGE_ID",
    SET_MESSAGES = "MESSAGEBOARD/SET_MESSAGES",
    SET_FILTERS = "MESSAGEBOARD/SET_FILTERS",
    ADD_MESSAGES = "MESSAGEBOARD/ADD_MESSAGES",
    SET_SELF_ADDED_MESSAGE_IDS = "MESSAGEBOARD/SET_SELF_ADDED_MESSAGE_IDS",
    SET_MENTIONS = "MESSAGEBOARD/SET_MENTIONS",
    LOAD_MENTIONS = "MESSAGEBOARD/LOAD_MENTIONS",
    SET_NOTIFICATION_RECIPIENTS = "MESSAGEBOARD/SET_NOTIFICATION_RECIPIENTS",
    LOAD_NOTIFICATION_RECIPIENTS = "MESSAGEBOARD/LOAD_NOTIFICATION_RECIPIENTS",
    UNDO_APPROVAL_STATUS = "MESSAGEBOARD/UNDO_APPROVAL_STATUS",
    SET_APPROVE = "MESSAGEBOARD/SET_APPROVE",
    SET_REJECT = "MESSAGEBOARD/SET_REJECT",
    SET_APPROVE_STATUS = "MESSAGEBOARD/SET_APPROVE_STATUS",
    RESET_ALL_APPROVES = "MESSAGEBOARD/RESET_ALL_APPROVES",
    SHOW_VERSION_DIALOG = "MESSAGEBOARD/SHOW_VERSION_DIALOG",
    HIDE_VERSION_DIALOG = "MESSAGEBOARD/HIDE_VERSION_DIALOG",
    TOGGLE_EXPANDED_ATTACHED = "MESSAGEBOARD/TOGGLE_EXPANDED_ATTACHED",
    OPEN_ANNOTATIONS_DIALOG = "MESSAGEBOARD/OPEN_ANNOTATIONS_DIALOG",
    UPDATE_VERSION_IMAGES_ANNOTATIONS = "MESSAGEBOARD/UPDATE_VERSION_IMAGES_ANNOTATIONS",
    REQUEST_AI_COMPLETION = "MESSAGEBOARD/REQUEST_AI_COMPLETION",
    RETRY_AI_COMPLETION = "MESSAGEBOARD/RETRY_AI_COMPLETION",
    RELOAD_REACTION = "MESSAGEBOARD/RELOAD_REACTION",
    UPDATE_REACTION = "MESSAGEBOARD/UPDATE_REACTION",
    UPDATE_REACTION_IN_STORE = "MESSAGEBOARD/UPDATE_REACTION_IN_STORE",
}
